export default "__VITE_ASSET__DU$Bk4x0__"